import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=5c0abe3b&"
import script from "./admin.vue?vue&type=script&lang=js&"
export * from "./admin.vue?vue&type=script&lang=js&"
import style0 from "./admin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\eoninnovaction\\Development\\administracion\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c0abe3b')) {
      api.createRecord('5c0abe3b', component.options)
    } else {
      api.reload('5c0abe3b', component.options)
    }
    module.hot.accept("./admin.vue?vue&type=template&id=5c0abe3b&", function () {
      api.rerender('5c0abe3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/admin.vue"
export default component.exports